import React, { Component } from "react";
import Menu from "../components/menu";
import Scroller from "../components/scroller";
import TopLink from "../components/topLink";
import htmlUtil from "../utils/htmlUtil";
import ReactGA from "react-ga4";

const LOCALES = {
  titre: {
    label: {
      fr: "Définitions",
      en: "Definitions",
    },
  },
};

class Definitions extends Component {
  constructor(props) {
    super(props);

    this._fetchDefinitions = this._fetchDefinitions.bind(this);

    this.page = "definitions";

    this.state = {
      content:
        this.props.lang === "en"
          ? "Loading content..."
          : "Chargement du contenu...",
    };
  }

  componentDidMount() {
    if (this.props.lang) {
      this._fetchDefinitions();
    }
    ReactGA.event("page_view", {
      page_title: LOCALES.titre.label[this.props.lang],
    });
  }

  render() {
    return (
      <div className="page page-definitions ">
        <Menu {...this.props} activePage={this.page} />
        <div id="contenu_centre">
          <h1>{LOCALES.titre.label[this.props.lang]}</h1>
          <hr />
          <div className="pad-t-10">{this._renderSubMenu()}</div>
          <div
            className="texte_petit"
            dangerouslySetInnerHTML={htmlUtil.getHTMLTextForReact(
              this.state.content
            )}
          ></div>
          <TopLink {...this.props} />
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.lang !== prevProps.lang) {
      this._fetchDefinitions();
    }
  }

  _renderSubMenu() {
    //Anglais
    if (this.props.lang === "en") {
      return (
        <ul className="row small list-unstyled">
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#trade_type_title">Trade type</Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#time_period_title">Time period</Scroller>
          </li>
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#value_in_title">Value</Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#trading_partner_title">
              Trading partner
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#product_selections_title">
              Product selection
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#harmonized_system_title">
              Harmonized System (HS)
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#industry_selections_title">
              Industry selection
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#naics_title">
              North American Industry Classification System (NAICS)
            </Scroller>
          </li>
        </ul>
      );
    }
    //Francais
    else {
      return (
        <ul className="row small list-unstyled">
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#trade_type_title">Type d'échange</Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#time_period_title">Période</Scroller>
          </li>
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#value_in_title">Valeur</Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#trading_partner_title">
              Partenaire commercial
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#product_selections_title">
              Sélection de produits
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#harmonized_system_title">
              Système Harmonisé (SH)
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-5">
            <Scroller selector="#industry_selections_title">
              Sélection des industries
            </Scroller>
          </li>
          <li className="col-xs-12 col-sm-7">
            <Scroller selector="#naics_title">
              Système de Classification des Industries de l’Amérique du Nord
              (SCIAN)
            </Scroller>
          </li>
        </ul>
      );
    }
  }
  _fetchDefinitions() {
    //Récupérer les definitions selon l'ancienne methode PHP
    fetch(`./hkc_Definitions_${this.props.lang === "en" ? "30" : "36"}.php`)
      .then((res) => {
        if (res.ok) {
          return res.text();
        }
      })
      .then((data) => {
        this.setState({ content: data });
      })
      .catch((error) => {
        console.error("Problèmes: getDefinitions", error);

        this.setState({
          content:
            this.props.lang === "en" ? "Not available..." : "Non disponible...",
        });
      });
  }
}

export default Definitions;
